import {Component} from "@angular/core";
import {Location} from "@angular/common";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: "fhm-app",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent {
    constructor(translate: TranslateService) {
        translate.setFallbackLang("en");
        translate.use(translate.getBrowserLang());
    }
}
